import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IInvestmentDateFilters } from '~/@api/generated-api-types-user/Api'

function useInvestmentsDateFiltersQuery() {
  const client = useApiClientUser()

  async function fetchDateFilters(): Promise<IInvestmentDateFilters> {
    return client.user
      .settingsControllerGetInvestmentDateFilters({
        secure: true,
      })
      .then((resp) => resp.data.data)
  }

  const { data, ...rest } = useQuery({
    queryKey: ['investments-date-filters'],
    queryFn: fetchDateFilters,
    throwOnError: false,
    placeholderData: keepPreviousData,
  })

  const { latestPaymentYearsOptions, investmentYearsOptions } = (() => {
    return {
      latestPaymentYearsOptions: (data?.latestPaymentYears ?? []).map(
        (latestPaymentYear) => ({
          label: latestPaymentYear.toString(),
          value: latestPaymentYear,
        })
      ),
      investmentYearsOptions: (data?.investmentYears ?? []).map(
        (investmentYear) => ({
          label: investmentYear.toString(),
          value: investmentYear,
        })
      ),
    }
  })()

  return {
    latestPaymentYearsOptions,
    investmentYearsOptions,
    ...rest,
  }
}

export { useInvestmentsDateFiltersQuery }
